import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';

const EditMealIndex = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    navigate(`${ROUTE_PREFIX.FOOD}/edit-meal/${id}/${ROUTE_KEYS.EDIT_MEAL_BRAND_DETAILS}`, {
      replace: true
    });
  }, []);

  return <div />;
};

export default EditMealIndex;
